export default class EnvManager {
    static get AUTH_URL () {
        return process.env.VUE_APP_AUTH_URL
    }
    static get API_URL () {
        return process.env.VUE_APP_API_URL
    }
}
